import { Footer, Header } from "./";
import { Row, TableRow } from "./row";

import { Empty } from "antd";
import React from "react";
import { UseTableInstanceProps } from "react-table";

interface BodyProps extends UseTableInstanceProps<object> {
	paginated?: boolean;
	expanded?: boolean;
	onRowPress?: Function;
	renderEmpty?: React.ReactNode;
	renderExpanded?: React.ReactNode;
}

export class Body extends React.PureComponent<BodyProps | any> {
	get rows() {
		// @ts-ignore
		const { rows, page, paginated } = this.props;
		return paginated ? page : rows;
	}

	get isEmpty() {
		return this.rows.length === 0;
	}

	renderRow = (rowProps: TableRow) => {
		const { prepareRow, expanded, onRowPress, renderExpanded } = this.props;
		prepareRow(rowProps);
		return (
			<Row
				key={`table_row_${rowProps.id}`}
				{...rowProps}
				onPress={onRowPress}
				expandable={expanded}
				renderExpanded={renderExpanded}
			/>
		);
	};

	renderContent() {
		if (!this.isEmpty)
			return (
				<React.Fragment>
					<Header
						headerGroups={this.props.headerGroups}
						resizable={this.props.resizable}
						sortable={this.props.sortable}
					/>
					<div className="TableBodyRows">{this.rows.map(this.renderRow)}</div>
				</React.Fragment>
			);

		const { renderEmpty } = this.props;

		return (
			<div
				className="TableBodyEmpty"
			>
				{typeof renderEmpty === "function" ? renderEmpty() : <Empty />}
			</div>
		);
	}

	render() {
		const { getTableBodyProps, isSinglePage } = this.props;

		return (
			<>
				<div
					{...(getTableBodyProps() as any)}
					className={`TableBody${isSinglePage ? " __singlePage" : ""}`}
				>
					{this.renderContent()}
				</div>
				{this.props.hasFiltration && (
					<Footer
						{...this.props}
						filtrationApi={this.props.filtrationApi}
						headerGroups={this.props.headerGroups}
					/>
				)}
			</>
		);
	}
}
